<template>
  <Collapse
    class="vendor-bid-status-list"
    :title="$t('tender.healthcheck')"
    :expand="false"
    :withBorder="false"
  >
    <HealthCheck slot="content" />
  </Collapse>
</template>
<script>
import Collapse from '@/controls/Collapse'
import { defineComponent } from '@vue/composition-api'
import HealthCheck from '@/modules/tenders/review/HealthCheck'

export default defineComponent({
  components: {
    Collapse,
    HealthCheck,
  },
})
</script>
<style lang="scss" scoped>
.vendor-bid-status-list {
  & ::v-deep .content {
    padding: 10px 24px 0 24px;
  }
  & ::v-deep .title-container {
    border-bottom: 1px solid #e0e0e0;
    padding: 0px 24px;
    .title-content {
      .default-title {
        color:#0c3a58;
        font-size: 22px;
        font-weight: normal;
        font-family: Verdana;
      }
    }
    .arrow {
      color: #27698D;
      font-size: 40px;
      font-weight: 500;
    }
    .fa-angle-down:before, .fa-angle-up:before {
      display: inline-block;
      content: '\2039';
      font-style: normal;
      font-size: 50px;
      color: #27698D;
      font-family: Verdana;
      top: 15px;
      margin-top: 0;
      right: 30px;
      padding-right: 15px;
      transform: rotate(-90deg);
    }
    .fa-angle-up:before {
      transform: rotate(90deg);
      padding-right: 0;
    }
  }
}
</style>
